import { render, staticRenderFns } from "./storeFeedbackDetail.vue?vue&type=template&id=123116fe&scoped=true"
import script from "./storeFeedbackDetail.vue?vue&type=script&lang=js"
export * from "./storeFeedbackDetail.vue?vue&type=script&lang=js"
import style0 from "./storeFeedbackDetail.vue?vue&type=style&index=0&id=123116fe&lang=scss"
import style1 from "./storeFeedbackDetail.vue?vue&type=style&index=1&id=123116fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123116fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123116fe')) {
      api.createRecord('123116fe', component.options)
    } else {
      api.reload('123116fe', component.options)
    }
    module.hot.accept("./storeFeedbackDetail.vue?vue&type=template&id=123116fe&scoped=true", function () {
      api.rerender('123116fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/storeFeedbackDetail.vue"
export default component.exports